export function usePaymentsPage() {
  return { title: 'Оплаты', description: 'История платежей' };
}
